<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
            @update:options="pagination"
            :server-items-length="serverItemsLength"
			:headers="headers"
			:items="cards"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

			<template #item.client="{item}">
				{{ item.client.name }} {{ item.client.email }} {{ item.client.tel }}
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/Card.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "cards-table",
		mixins: [new FilterAble(types,true)],
		data() {
			return {
				loading: false,
				headers: [
					{
						text: "מספר כרטיס", value: "number"
					},
					{
						text: "לקוח", value: "client",sortable:false
					},
					{
						text: "הגרלה", value: "lottery.title",sortable:false
					},
					// {
					// 	text: "is_won", value: "is_won"
					// }
				],
				lookingFor: null,
				showDialog: false
			};
		},
		computed: {
			cards() {
				return this.$store.state.CardModule.cards;
			}
		},
		methods: {
			onEdit(Card) {
				this.$emit("edit", Card);
			}
		}, watch:{
        lookingFor(value){
            this.freeSearch(value,
                ["number"]

            )
        }
    }
	}
	;
</script>

<style>

</style>
